import React, { useEffect, useState } from "react";
import { Card, Tag, Typography, Row, Col, Button, Spin } from "antd";
import {
  ClockCircleOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../Config";

const { Text, Title } = Typography;

const ExtensionTimer = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

 

 useEffect(() => {
  const fetchStatus = async () => {
    try {
      const token = sessionStorage.getItem("token"); // ← move inside
      const res = await axios.get(`${BASE_URL}/extension/status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        setData(res.data.data);
      }
    } catch (err) {
      console.error("Extension status fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchStatus();
}, []);
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <Spin size="small" />
      </div>
    );
  }

  if (!data || data.totalVariations === 0) {
    return (
      <Card style={styles.card}>
        <div style={{ textAlign: "center", padding: "10px 0" }}>
          <ClockCircleOutlined style={{ fontSize: 28, color: "#94a3b8" }} />
          <div style={{ marginTop: 8 }}>
            <Text type="secondary">No media links yet</Text>
          </div>
        </div>
      </Card>
    );
  }

  // ── Color config per status ──────────────────────────────────
  const config = {
    active: {
      color: "#10b981",
      bg: "#f0fdf4",
      border: "#bbf7d0",
      icon: <CheckCircleOutlined style={{ color: "#10b981", fontSize: 22 }} />,
      label: "Active",
      tagColor: "success",
    },
    "expiring-soon": {
      color: "#f59e0b",
      bg: "#fffbeb",
      border: "#fde68a",
      icon: <WarningOutlined style={{ color: "#f59e0b", fontSize: 22 }} />,
      label: "Expiring Soon",
      tagColor: "warning",
    },
    expired: {
      color: "#ef4444",
      bg: "#fef2f2",
      border: "#fecaca",
      icon: <CloseCircleOutlined style={{ color: "#ef4444", fontSize: 22 }} />,
      label: "Expired",
      tagColor: "error",
    },
  };

  const cfg = config[data.status];

  return (
    <Card
      style={{
        ...styles.card,
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
      }}
    >
      {/* ── Header ── */}
      <div style={styles.header}>
        {cfg.icon}
        <div style={{ flex: 1 }}>
          <Text strong style={{ fontSize: 14, color: cfg.color }}>
            Media Link Extension
          </Text>
          <div>
            <Tag color={cfg.tagColor} style={{ marginTop: 2 }}>
              {cfg.label}
            </Tag>
          </div>
        </div>
      </div>

      {/* ── Countdown ── */}
      {data.status !== "expired" && data.soonestExpiryDate && (
        <div style={styles.countdown}>
          <div style={styles.timeBox}>
            <Text strong style={{ fontSize: 28, color: cfg.color }}>
              {data.daysRemaining}
            </Text>
            <Text type="secondary" style={{ fontSize: 11 }}>
              days
            </Text>
          </div>
          <Text type="secondary" style={{ fontSize: 20, margin: "0 4px" }}>
            :
          </Text>
          <div style={styles.timeBox}>
            <Text strong style={{ fontSize: 28, color: cfg.color }}>
              {data.hoursRemaining}
            </Text>
            <Text type="secondary" style={{ fontSize: 11 }}>
              hours
            </Text>
          </div>

          <div style={{ marginLeft: 12 }}>
            <Text type="secondary" style={{ fontSize: 11, display: "block" }}>
              Soonest expiry
            </Text>
            <Text style={{ fontSize: 12 }}>
              {new Date(data.soonestExpiryDate).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </Text>
          </div>
        </div>
      )}

      {data.status === "expired" && (
        <div style={{ textAlign: "center", padding: "8px 0" }}>
          <Text type="danger" strong>
            One or more media links have expired
          </Text>
        </div>
      )}

      {/* ── Summary stats ── */}
      <Row gutter={8} style={{ marginTop: 12 }}>
        <Col span={8}>
          <div style={styles.statBox("#f0fdf4", "#10b981")}>
            <Text strong style={{ color: "#10b981", fontSize: 16 }}>
              {data.totalActive}
            </Text>
            <Text type="secondary" style={{ fontSize: 10 }}>
              Active
            </Text>
          </div>
        </Col>
        <Col span={8}>
          <div style={styles.statBox("#fffbeb", "#f59e0b")}>
            <Text strong style={{ color: "#f59e0b", fontSize: 16 }}>
              {data.totalExpiringSoon}
            </Text>
            <Text type="secondary" style={{ fontSize: 10 }}>
              Expiring soon
            </Text>
          </div>
        </Col>
        <Col span={8}>
          <div style={styles.statBox("#fef2f2", "#ef4444")}>
            <Text strong style={{ color: "#ef4444", fontSize: 16 }}>
              {data.totalExpired}
            </Text>
            <Text type="secondary" style={{ fontSize: 10 }}>
              Expired
            </Text>
          </div>
        </Col>
      </Row>

      {/* ── Extend now button ── */}
      {(data.status === "expiring-soon" || data.status === "expired") && (
        <Button
          type="primary"
          block
          size="small"
          danger={data.status === "expired"}
          style={{
            marginTop: 12,
            background: data.status === "expired" ? "#ef4444" : "#f59e0b",
            borderColor: data.status === "expired" ? "#ef4444" : "#f59e0b",
          }}
          onClick={() => navigate("/extend")}
        >
          Extend Now
        </Button>
      )}
    </Card>
  );
};

const styles = {
  card: {
    borderRadius: 12,
    marginTop: 12,
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    marginBottom: 12,
  },
  countdown: {
    display: "flex",
    alignItems: "center",
    background: "rgba(255,255,255,0.6)",
    borderRadius: 8,
    padding: "8px 12px",
    marginBottom: 4,
  },
  timeBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: 44,
  },
  statBox: (bg, color) => ({
    background: bg,
    borderRadius: 8,
    padding: "6px 4px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }),
};

export default ExtensionTimer;